import {createSlice} from '@reduxjs/toolkit'

export const authSlice = createSlice({
    name:'auth',
    initialState: { 
        uid:null,
        accessToken:null, 
        isLoading: false,
        error: false,
        error_message:""
    },
    reducers:{
        getAuthFetch : (state)=>{
            state.isLoading = true;
            state.error = false
            state.error_message = ""
        },
        getAuthSuccess : (state,action)=>{
            state.isLoading = false
            state.accessToken = action.payload.accessToken
            state.uid = action.payload.uid  
            state.error = false
            state.error_message = ""
        },
        getAuthFail: (state,action)=>{
            state.isLoading = false
            state.error = true
            state.error_message = action.payload.message
        },
        getLogout:(state)=>{
            state.accessToken = null
            state.uid = null
        }

    }
})
export const selectIsLoading = (state)=> state.auth.isLoading
export const selectAccessToken = (state)=> state.auth.accessToken
export const selectUid = (state)=> state.auth.uid
export const {getAuthFetch,getAuthSuccess,getAuthFail,getLogout} = authSlice.actions;
export default authSlice.reducer